<template>
    <div class="align-center app-pagination-layout">
        <div class="app-pagination-layout_header">
            <div class="pagination-header-left">
                <slot name="header"></slot>
            </div>
            <el-input v-if="showSearch" class="pagination-search-input input-height"
                      :placeholder="searchPlaceholder"
                      suffix-icon="el-icon-search"
                      clearable
                      @blur="toSearchKey"
                      @clear="clearSearch"
                      @keyup.enter.native="toBlur($event)"
                      v-model.trim="mySearchKey"/>
        </div>
        <div class="app-pagination-layout_content">
            <slot name="content"></slot>
        </div>
        <div class="align-center app-pagination-layout_bottom" v-show="showPagination">
            <span class="pagination-total">共{{total}}条记录</span>
            <div class="align-center pagination-operate">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :pager-count="pagerCount"
                    :page-size.sync="myPageSize"
                    :current-page.sync="myPageNo"
                    :total="total"
                    @current-change="currentPageChange">
                </el-pagination>
                <el-select class="pagination-sizes input-height"
                           v-model="myPageSize"
                           placeholder="请选择" @change="pageSizeChange">
                    <el-option
                        v-for="item in sizeOptions"
                        :key="item"
                        :label="item + sizeFlag + '/页'"
                        :value="item">
                    </el-option>
                </el-select>
                <div class="align-center pagination-jump-wrapper">
                    <span>跳至</span>
                    <el-input class="input-height jump-input"
                              v-model.trim="jumpPageNo"
                              @blur="jumpPageChange"
                              @keyup.enter.native="toJumpPageBlur($event)"/>
                    <span>页</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app-pagination-layout',
    props: {
        total: {
            type: [Number, String],
            default: 0
        },
        searchPlaceholder: {
            type: String,
            default: '请输入'
        },
        searchKey: {
            type: String,
            default: ''
        },
        pagerCount: {
            type: Number,
            default: 5
        },
        pageNo: {
            type: [Number, String],
            default: 1
        },
        pageSize: {
            type: [Number, String],
            default: 10
        },
        // 单页显示数量的单位
        sizeFlag: {
            type: String,
            default: '条' // 个
        },
        showSearch: {
            type: Boolean,
            default: true
        },
        sizeOptions: {
            type: Array,
            default: () => {
                return [10, 20, 50, 100];
            }
        }
    },
    data () {
        return {
            showPagination: true,
            mySearchKey: '',
            jumpPageNo: 1,
            myPageNo: this.pageNo,
            myPageSize: this.pageSize,
            mySizeOptions: this.sizeOptions,
            maxPageCount: 1
        };
    },
    watch: {
        total: {
            handler (val) {
                this.showPagination = val;
                this.formatPaginationData();
            }
        },
        searchKey: {
            handler (val) {
                this.mySearchKey = val;
            },
            immediate: true
        },
        mySearchKey: {
            handler (val) {
                this.$emit('update:searchKey', val);
            }
        },
        pageSize: {
            handler (val) {
                this.myPageSize = val;
            },
            immediate: true
        },
        pageNo: {
            handler (val) {
                this.myPageNo = val;
            },
            immediate: true
        }
    },
    created () {
        if (this.sizeOptions && this.sizeOptions.length) {
            this.mySizeOptions = this.sizeOptions;
        }
    },
    methods: {
        formatPaginationData () {
            let num = this.total / this.myPageSize;
            let str = (num + '').split('.');
            if (str[0] === '0') {
                this.maxPageCount = 1;
            } else if (str[1] === '0') {
                this.maxPageCount = +str[0];
            } else {
                this.maxPageCount = +str[0] + 1;
            }
        },
        pageSizeChange (num) {
            this.$emit('update:pageSize', num);
            this.$emit('update:pageNo', 1);
            this.formatPaginationData();
            this.toQueryList();
        },
        jumpPageChange () {
            if (this.jumpPageNo > this.maxPageCount) {
                this.jumpPageNo = this.maxPageCount;
            }
            // 判断输入的值是否为正整数
            const reg = /^[1-9]\d*$/;
            if (!reg.test(this.jumpPageNo)) {
                // 不是正整数，则将输入框的值设为1
                this.jumpPageNo = 1;
            }
            this.currentPageChange(this.jumpPageNo);
        },
        toJumpPageBlur (event) {
            event.target.blur();
        },
        currentPageChange (num) {
            this.$emit('update:pageNo', num);
            this.toQueryList();
        },
        clearSearch () {
            this.mySearchKey = '';
            this.currentPageChange(1);
            this.$nextTick(() => {
                this.toQueryList();
            });
        },
        toSearchKey () {
            this.currentPageChange(1);
        },
        toQueryList () {
            this.$emit('queryList');
        },
        toBlur ($event) {
            $event.target.blur();
        }
    }
};
</script>

<style scoped lang="scss">
.align-center {
    display: flex;
    align-items: center;
}
.app-pagination-layout {
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 24px 24px 0 24px;
    overflow: hidden;
    background: var(--knowledge-right-bg);
    .app-pagination-layout_header,
    .app-pagination-layout_content,
    .app-pagination-layout_bottom {
        width: 100%;
    }
    ::v-deep {
        .el-table tr, .el-table, .el-table th.el-table__cell, .el-table__row {
            background-color: transparent;
            color: var(--knowledge-text);
        }
        .el-table__fixed-right::before, .el-table__fixed::before, .el-table__fixed-right-patch {
            background-color: transparent;
        }
        td {
            background-color: transparent!important;
            border-bottom: 1px solid rgba(0,0,0,0.15);
        }
        .el-input__inner {
            background-color: var(--knowledge-right-bg);
            color: var(--knowledge-text);
            border-color: var(--border-color);
        }
        .el-input__inner:hover, .el-input__inner:focus {
            border-color: var(--border-color-hover);
        }
    }
    .app-pagination-layout_header {
        position: relative;
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        .pagination-search-input {
            width: 240px;
        }
    }
    .app-pagination-layout_content {
        flex: 1;
        overflow: hidden;
        padding-bottom: 24px;
    }
    .app-pagination-layout_bottom {
        justify-content: space-between;
        color: var(--knowledge-text);
        padding-bottom: 24px;
        .pagination-operate {
            ::v-deep {
                .btn-prev, .number, .btn-quicknext, .btn-next {
                    background-color: var(--knowledge-right-bg);
                    color: var(--knowledge-text);
                    border: 1px solid var(--border-color);
                }
                .number.active {
                    border: unset;
                }
                .el-icon-arrow-left, .el-icon-arrow-right {
                    padding-top: 2px;
                }
            }
            .pagination-sizes {
                width: 110px;
            }
            .pagination-jump-wrapper {
                white-space: nowrap;
                margin-left: 8px;
                .jump-input {
                    width: 48px;
                    margin: 0 8px;
                }
            }
        }
    }
}
</style>
